//
// Current ver:
//
//     https://github.com/nhz-io/react-canvas-component/blob/ad9d19df638cf6d5f5c79c60f28c8f2ab2aae3ae/src/ReactCanvasComponent.jsx
//     (with insignificant changes)
//

/* eslint-disable */
import requestAnimationFrame from 'raf'
// The file is vendored as-is to easen patching from upstream

import React from 'react'
type Props = {
  draw: (...args: Array<any>) => any
  realtime: boolean
  top: number
  left: number
  style: Record<string, any>
  width: number
  height: number
  onMouseDown?: (...args: Array<any>) => any
  onMouseUp?: (...args: Array<any>) => any
  onMouseMove?: (...args: Array<any>) => any
  onMouseLeave?: (...args: Array<any>) => any
  onTouchStart?: (...args: Array<any>) => any
  onTouchMove?: (...args: Array<any>) => any
  onTouchEnd?: (...args: Array<any>) => any
}
export default class Component extends React.Component<Props> {
  static defaultProps: {
    draw: () => void
    left: number
    realtime: boolean
    top: number
  } = {
    draw: function () {},
    realtime: false,
    top: 0,
    left: 0,
  }
  _canvas: any
  previousFrameTime: number | null | undefined

  constructor(props: Props) {
    super(props)
    this._canvas = React.createRef()
  }

  componentDidMount() {
    this.forceUpdate()
    requestAnimationFrame(this.requestAnimationFrameCallback)
  }

  render(): React.ReactElement<'canvas'> {
    const { props } = this
    requestAnimationFrame(this.requestAnimationFrameCallback)
    const { left, top, realtime, draw, ...canvasProps } = props
    return <canvas ref={this._canvas} key="canvas" {...canvasProps} />
  }

  requestAnimationFrameCallback: (time: number) => void = (time: number) => {
    if (this.previousFrameTime !== time) {
      const { props, refs } = this
      const { draw, top, left } = props

      const ctx =
        this._canvas &&
        this._canvas.current &&
        this._canvas.current.getContext('2d')

      const realtime = props.realtime
      let delta = 0

      if (draw && ctx) {
        if (realtime) {
          requestAnimationFrame(this.requestAnimationFrameCallback)

          if (!this.previousFrameTime) {
            this.previousFrameTime = time
          } else {
            delta = time - this.previousFrameTime
          }

          this.previousFrameTime = time
        }

        if (top || left) {
          ctx.translate(left, top)
        }

        draw({
          time: time,
          delta: delta,
          ctx: ctx,
        })

        if (top || left) {
          ctx.translate(-1 * left, -1 * top)
        }
      }
    }
  }
}
